// @core/api/endpoints/platform/update_platform_product.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PlatformProductResponse,
  UpdatePlatformProductRequest,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Update platform product configuration
 * Updates the configuration for a product on the platform. Allows changing branding, available plans, feature flags, and limits.
 */
export async function UpdatePlatformProduct(
  platform_id: string,
  product_id: string,
  data: UpdatePlatformProductRequest,
  options?: RequestOptions
): Promise<PlatformProductResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/platforms/:platform_id/products/:product_id`;
  requestPath = requestPath.replace(':platform_id', encodeURIComponent(platform_id));
  requestPath = requestPath.replace(':product_id', encodeURIComponent(product_id));
  const requestOptions = options;
  return client.put<PlatformProductResponse>(requestPath, data, requestOptions);
}
